export default __webpack_public_path__ + "static/media/bowlers-card-img-2.6f4d5c51.png";